module.exports = __webpack_public_path__ + "r-v3/img/mic_on_white.f62ed524.svg";